import React from 'react';

export const LoaderSkeleton = ({ count = 20 }) => {
  const CellLoader = () => (
    <td className="flex-1 py-2 pr-4 pl-2">
      <div className="h-5 animate-pulse bg-gray-200 rounded-md">&nbsp;</div>
    </td>
  );
  return (
    <>
      {new Array(count).fill(0).map((_, id) => (
        <tr key={id} data-testid="skeleton-item" className="my-2">
          <td className="flex items-center py-[8px] pr-4 pl-2">
            <div className="mr-4 flex w-full">
              <div className="h-[36px] min-w-[56px] animate-pulse bg-gray-200 mr-4 rounded-md">
                &nbsp;
              </div>
              <div className="my-auto w-full">
                <div className="h-5 animate-pulse bg-gray-200 rounded-md">
                  &nbsp;
                </div>
              </div>
            </div>
          </td>

          {CellLoader()}
          {CellLoader()}
          {CellLoader()}
          {CellLoader()}
          {CellLoader()}
          {CellLoader()}
          {CellLoader()}
          {CellLoader()}
        </tr>
      ))}
    </>
  );
};
